export const WELCOME_JOURNEY = 'welcome-journey';
export const REFERRAL_MARKETING = 'referral-marketing';
export const MY_BOOKS = 'my-books';
export const CAMPAIGNS = 'Campaigns';
export const LEADS = 'Leads';
export const TRAINING = 'Training';